(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('SellerActivityService', SellerActivityService);

    SellerActivityService.$inject = ['SellerActivityFactory'];

    function SellerActivityService(SellerActivityFactory) {
        var service = {
            findByCampaignId: findByCampaignId,
            updateStatus: updateStatus
        };

        return service;

        function findByCampaignId(pageable, params) {
            return SellerActivityFactory.findByCampaignId(pageable, params).$promise;
        }

        function updateStatus(id, body) {
            return SellerActivityFactory.updateStatus({id: id}, body).$promise;
        }
    }
})();
